import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Menu from '@zenbusiness/zui/Menu';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const ProfileMenuDropdown = superstyled({
  name: 'ProfileMenu',
  slot: 'Dropdown',
  tag: Menu
});

export const ProfileContainer = superstyled({
  name: 'ProfileMenu',
  slot: 'ProfileContainer',
  tag: Box,
  styles: ({ theme }) => ({
    padding: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: theme.spacing(2)
  })
});

export const ProfileButton = superstyled({
  name: 'ProfileMenu',
  slot: 'ProfileButton',
  tag: Button,
  styles: ({ theme }) => ({
    padding: theme.spacing(1),
    backgroundColor: 'transparent',
    borderRadius: theme.spacing(1),
    border: '1px solid rgba(255, 255, 255, 0.16)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)'
    }
  })
});

export const UserInfoContainer = superstyled({
  name: 'ProfileMenu',
  slot: 'UserInfoContainer',
  tag: Box,
  styles: () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    textAlign: 'left'
  })
});

export const ButtonContainer = superstyled({
  name: 'ProfileMenu',
  slot: 'ButtonContainer',
  tag: Box,
  styles: () => ({
    width: '100%',
    alignSelf: 'center'
  })
});
